import { isAvailableStrict, FDealType, FOfferType } from '../../../../../packages/JsonQuery';
import { IFilterSet, TFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.Hotel;

export const HOTEL_FILTERS_SET: IFilterSet<TFilter>[] = [
  {
    availability: isAvailableStrict(FDealType.RentDaily, OFFER_TYPE),
    list: ['dealType', 'dates', 'beds', 'offerType', 'price', 'starRating', 'geo'],
  },
];
